__turbopack_context__.v({
  "className": "NkvnZG_className",
  "variable": "NkvnZG_variable",
});
